import React from 'react';
import { PaymentResponse } from '../../types/payment';
import { copyToClipboard } from '../../utils/paymentApi';

interface BoletoPaymentProps {
  paymentResponse: PaymentResponse | null;
}

const BoletoPayment: React.FC<BoletoPaymentProps> = ({ paymentResponse }) => {
  const handleCopyBarcode = async () => {
    if (paymentResponse?.boletoBarcode) {
      const success = await copyToClipboard(paymentResponse.boletoBarcode);
      if (success) {
        alert('Linha digitável copiada com sucesso!');
      } else {
        alert('Erro ao copiar a linha digitável. Por favor, tente novamente.');
      }
    }
  };

  if (!paymentResponse) {
    return (
      <p>Você selecionou pagamento via Boleto/PIX. Após preencher seus dados, você receberá as opções de pagamento.</p>
    );
  }

  return (
    <div className="boleto-info">
      <div className="boleto-content">
        <div className="boleto-section">
          <p>
            <strong>Valor:</strong> 
            <span>R$ {paymentResponse.value?.toFixed(2).replace('.', ',')}</span>
          </p>
          <p>
            <strong>Vencimento:</strong> 
            <span>{paymentResponse.dueDate}</span>
          </p>
        </div>

        {paymentResponse.boletoBarcode && (
          <div className="boleto-section">
            <p style={{
              fontFamily: 'monospace',
              fontSize: '16px',
              wordBreak: 'break-all',
              textAlign: 'center',
              background: '#fff',
              padding: '15px',
              borderRadius: '6px',
              border: '1px solid #e0e0e0',
              margin: '15px 0'
            }}>
              {paymentResponse.boletoBarcode}
            </p>
            <button 
              type="button" 
              className="copy-button" 
              onClick={handleCopyBarcode}
            >
              COPIAR LINHA DIGITÁVEL
            </button>
          </div>
        )}

        <div className="boleto-buttons">
          {paymentResponse.bankSlipUrl && (
            <a 
              href={paymentResponse.bankSlipUrl} 
              className="btn" 
              target="_blank"
              rel="noopener noreferrer"
            >
              BAIXAR BOLETO
            </a>
          )}
          {paymentResponse.invoiceUrl && (
            <a 
              href={paymentResponse.invoiceUrl} 
              className="btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              VISUALIZAR ONLINE
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default BoletoPayment;